import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=39a75f10&"
import script from "./UserDetail.vue?vue&type=script&lang=js&"
export * from "./UserDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a75f10')) {
      api.createRecord('39a75f10', component.options)
    } else {
      api.reload('39a75f10', component.options)
    }
    module.hot.accept("./UserDetail.vue?vue&type=template&id=39a75f10&", function () {
      api.rerender('39a75f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/User/UserDetail.vue"
export default component.exports